import React from 'react'
import Problems from './Components/Problems/Problems'
import PatientRiskScore from './Components/Patient Risk Score/PatientRiskScore'
import Allergies from './Components/Allergies/Allergies'
import HealthConcern from './Components/Health Concern/HealthConcern'
import ImplantableDevices from './Components/Implantable Devices/ImplantableDevices'
import AdvanceDirectives from './Components/Advance Directives/AdvanceDirectives'
import Goals from './Components/Goals/Goals'
import Appointments from './Components/Appointments/Appointments'
import { FindFirstChild } from '../../../../../../../../../utils/FindMenuOption'

const Summary = ({ expandAll, data, setIsRecordSaved, ...props }) => {

  //================== Encounter ===================//
  
  let SUMMARY_DATA = {
    "PatientProblemList": [],
    "PatientRiskScore": [],
    "PatientAllergy": [],
    "PatientHealthConcern": [],
    "PatientImplantableDevice": [],
    "PatientAdvanceDirectives": [],
    "PatientGoal": [],
    "PatientAppointment": []
  }
  let  { PatientData, ...summaryData } = data || {};
  summaryData = { ...SUMMARY_DATA, ...summaryData };

  let isViewAllowed = FindFirstChild('Patient', 'Encounter')?.ISView ?? true;
  let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd ?? true;
  let IsDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted ?? true;

  return (
    <div className='pb-2'>
        <p className='heading fs-14 pb-1'>HEALTH RECORDS</p>
        <div className='d-flex flex-column gap-2'>
            <Problems expandAll={expandAll} data={summaryData.PatientProblemList} setIsRecordSaved={setIsRecordSaved} setIsRecordSavedType={props?.setIsRecordSavedType} patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <PatientRiskScore expandAll={expandAll} data={summaryData.PatientRiskScore} setIsRecordSaved={setIsRecordSaved}patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <Allergies expandAll={expandAll} data={summaryData.PatientAllergy} setIsRecordSaved={setIsRecordSaved} patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <HealthConcern expandAll={expandAll} data={summaryData.PatientHealthConcern} setIsRecordSaved={setIsRecordSaved}patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <ImplantableDevices expandAll={expandAll} data={summaryData.PatientImplantableDevice} setIsRecordSaved={setIsRecordSaved} patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <AdvanceDirectives expandAll={expandAll} data={summaryData.PatientAdvanceDirectives} setIsRecordSaved={setIsRecordSaved}patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <Goals expandAll={expandAll} data={summaryData.PatientGoal} setIsRecordSaved={setIsRecordSaved}patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
            <Appointments expandAll={expandAll} data={summaryData.PatientAppointment} setIsRecordSaved={setIsRecordSaved} patientID={props?.patientID} isViewAllowed={isViewAllowed} IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}/>
        </div>

    </div>
  )
}

export default Summary